export enum Validations {
  required = 'required',
  minlength = 'minlength',
  maxlength = 'maxlength',
  alpha = 'alpha',
  email = 'email',
  pattern = 'pattern',
}
